import {
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';

interface ThankYouTitleProps {
	notALayer?: boolean;
	regularCopyFirst?: string;
	boldCopyFirst?: string;
	regularCopySecond?: string;
	boldCopySecond?: string;
}

export const ThankYouTitle = (props: ThankYouTitleProps) => {
	const {
		regularCopyFirst,
		boldCopyFirst,
		regularCopySecond,
		boldCopySecond,
	} = props;
	return (
		<Text
			appearance={TokenTextAppearance.headline300}
			textAlign={TextAlignment.left}
		>
			{regularCopyFirst ? <>{regularCopyFirst} </> : null}
			{boldCopyFirst ? <Text bold>{boldCopyFirst}</Text> : null}
			{regularCopySecond ? <>{regularCopySecond} </> : null}
			{boldCopySecond ? <Text bold>{boldCopySecond}</Text> : null}
		</Text>
	);
};
